import { make } from "vuex-pathify";

// properties
const state = {
  items: [],
};
const mutations = make.mutations(state);
const getters = {
  ...make.getters(state),
};
const actions = {
  async bindLists({ dispatch, rootGetters }, data) {
    dispatch("openDBChannel", {
      pathVariables: {
        teamId: rootGetters["user/getTeam"],
      },
    });
  },

  unbindLists({ dispatch }) {
    dispatch("closeDBChannel");
  },

  async add({ dispatch, rootGetters, getters }, data) {
    return dispatch("set", data);
  },

  async edit({ dispatch }, { task, data }) {
    await dispatch("patch", {
      id: task.id,
      ...data,
    });
  },

  // we move the task to the trashed collection
  async remove({ dispatch }, task) {
    await dispatch("patch", {
      id: task.id,
      status: "trashed",
    });
  },
};

export default {
  firestorePath: "teams/{teamId}/teamTasksLibrary",
  firestoreRefType: "collection",
  moduleName: "team-tasks-library",
  statePropName: "items",
  sync: {
    guard: ["id", "project_id", "status"],
    defaultValues: {
      status: "published",
      version: 1,
    },
  },
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
